import { BedType } from 'src/types/cartography.types';

/**
 * Référentiel front des types de lit — miroir exact de l'enum back.
 * `capacity` doit rester identique à BED_CAPACITY côté API.
 * `defaultWidthCm` / `defaultLengthCm` sont pré-remplis dans la modale d'ajout
 * et restent modifiables par l'utilisateur.
 */
export interface BedTypeDescriptor {
  type: BedType;
  capacity: number;
  defaultWidthCm: number;
  defaultLengthCm: number;
}

export const BED_TYPES: Record<BedType, BedTypeDescriptor> = {
  [BedType.SINGLE]: { type: BedType.SINGLE, capacity: 1, defaultWidthCm: 90, defaultLengthCm: 190 },
  [BedType.DOUBLE]: {
    type: BedType.DOUBLE,
    capacity: 2,
    defaultWidthCm: 140,
    defaultLengthCm: 190,
  },
  [BedType.QUEEN]: { type: BedType.QUEEN, capacity: 2, defaultWidthCm: 160, defaultLengthCm: 200 },
  [BedType.KING]: { type: BedType.KING, capacity: 2, defaultWidthCm: 180, defaultLengthCm: 200 },
  [BedType.BUNK]: { type: BedType.BUNK, capacity: 2, defaultWidthCm: 90, defaultLengthCm: 190 },
  [BedType.SOFA_BED]: {
    type: BedType.SOFA_BED,
    capacity: 2,
    defaultWidthCm: 140,
    defaultLengthCm: 190,
  },
  [BedType.BABY]: { type: BedType.BABY, capacity: 1, defaultWidthCm: 60, defaultLengthCm: 120 },
  [BedType.COT]: { type: BedType.COT, capacity: 1, defaultWidthCm: 70, defaultLengthCm: 140 },
};

export const BED_TYPE_LIST: BedTypeDescriptor[] = Object.values(BED_TYPES);
